export default "__VITE_ASSET__C3xyOVPz__"